// extracted by mini-css-extract-plugin
export default {"productThumbnails":"QZ-z","zoomMode":"RZ-z","carousel":"SZ-z","slides":"TZ-z","slide":"UZ-z","slideThumb":"VZ-z","nav":"WZ-z","fadeIn":"XZ-z","mounting":"YZ-z","horizontal":"ZZ-z"};